import { Tooltip } from 'bootstrap';

// tooltips
export const initTooltips = () => {
    const isLegacy = $('body').hasClass('legacy-master');

    if (isLegacy) {
        // BOOTSTRAP 3 (jQuery-based)
        const $targets = $('[data-toggle="tooltip"], [rel="tooltip"]');

        // Use 'container: body' to prevent z-index/overflow clipping in legacy layouts
        $targets.each(function() {
            const $el = $(this);

            $el.tooltip({
                container: 'body',
                trigger: 'hover',
            });

        });
    } else {

        // BOOTSTRAP 5 (Vanilla JS-based)
        const bs5Targets = document.querySelectorAll('[data-bs-toggle="tooltip"], [rel="tooltip"], [data-toggle="tooltip"]');

        [...bs5Targets].forEach(el => {
            new Tooltip(el, {
                container: 'body',
            });
        });
    }
}

// on page load
$(function () {
    initTooltips();

    $(document).ajaxComplete(() => {
        setTimeout(() => {
        initTooltips();
        }, 0);//push the execution to the end of the current message queue

    });
});